<script>
import Chat from "./Chat";

const axios = require('axios').default;
import moment from 'moment';
moment().format();

export default {

  name: 'ChatUserViewer',

  components: {Chat},

  mixins: [axios],

  props: {
    route: {
      required: true,
      type: String,
    },
    channels: {
      required: true,
      type: Array,
      default: function () {
        return [];
      }
    },
    counties: {
      required: true,
      type: Object,
    },
    userCountyFips: {
      required: false,
      default: [],
      type: Array,
    },
    user: {
      required: true,
      type: Object,
      default: function () {
        return {};
      },

    },
    isAdmin: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeConversation: null,
      unread: [],
      channelsList: [],
      showResultQuestion: false,
      results: {1: 'I&A', 2: 'Information Given', 3: 'Abandoned'}
    };
  },

  computed: {},

  created() {
    this.channelsList = this.channels

    this.channel = window.Echo.channel('chat.management')
    console.log('channel:', this.channel);
    this.channel.listen('ChatChannelCreated', (e, app) => {
      console.log('fips', this.userCountyFips);
      if (this.isAdmin || this.userCountyFips.includes(e.channel.county_fips)) {
        this.channelsList.unshift({
          'id': e.channel.id,
          'messages': [],
          'county_fips': e.channel.county_fips,
          'is_aging': e.channel.is_aging,
        });
        this.markAsUnRead(e.channel.id)
      }

      console.log({
        'id': e.channel.id,
        'messages': [],
        'county_fips': e.channel.county_fips,
        'is_aging': e.channel.is_aging,
      })

    });
  },

  methods: {

    notify(channelID) {
      if (this.activeConversation !== channelID) {
        this.markAsUnRead(channelID)
      }
    },

    openConversation(channelID) {
      this.showResultQuestion = false;
      this.activeConversation = channelID
      this.$refs['chat-' + channelID][0].refreshMessages()

      this.markAsRead(channelID)
    },

    markAsRead(channelID) {
      let index = this.unread.indexOf(channelID);
      if (index !== -1) {
        this.unread.splice(index, 1);
      }
    },

    markAsUnRead(channelID) {
      if (this.unread.indexOf(channelID) === -1) {
        this.unread.push(channelID)
      }
    },

    countyName(fips) {
      return this.counties[fips]
    },

    setMessage(message) {
      this.$refs['chat-' + this.activeConversation][0].message = message
    },

    setResult(channelID, result) {
      axios.post('/app/channels/' + channelID + '/result', {result: result}).then((response) => {
        let channelToUpdateIndex = this.channelsList.findIndex(c => c.id === channelID)
        this.channelsList[channelToUpdateIndex].result = response.data.channel.result
      }).catch(function (errors) {
        console.log(errors)
      })
    },

    formatTime(value){
      return moment(value).fromNow()
    }
  },
};

</script>

<template>
  <div class="w-full h-screen flex flex-row bg-white border p-2">
    <div class="flex-grow-0 w-1/4">
      <div class="flex flex-col items-center bg-indigo-100 border border-gray-200 mt-4 w-full py-6 px-4 rounded-lg">
        <div class="flex items-center justify-center h-8 w-8 bg-indigo-200 rounded-full">{{ user.name.substr(0, 1) }}
        </div>
        <div class="text-sm font-semibold mt-2">{{ user.name }}</div>
      </div>
      <div class="flex flex-col mt-3">
        <div v-for="channelData in channelsList" class="flex flex-col border-b-default border-gray-200">
          <button
              :class="`flex flex-row items-center hover:bg-gray-100 rounded-lgf px-2 py-3 ` + (channelData.id === activeConversation  ? 'bg-gray-200': '')"
              @click="openConversation(channelData.id)">
            <div class="flex items-center justify-center h-8 w-8 bg-indigo-200 rounded-full relative p-5">
              :)
              <span class="animate-ping absolute top-0 right-0 inline-flex rounded-full h-3 w-3 bg-blue-default"
                    v-if="unread.includes(channelData.id)"></span>
              <span class="absolute top-0 right-0 inline-flex rounded-full h-3 w-3 bg-blue-default"
                    v-if="unread.includes(channelData.id)"></span>
            </div>
            <div class="ml-4 text-sm flex flex-col text-left">
              <p><span class="font-semibold">County:</span> {{ countyName(channelData.county_fips) }}</p>
              <p><span class="font-semibold">Category:</span> {{ channelData.is_aging ? 'Aging' : 'Disability' }}</p>
              <p class="italic">Created {{ formatTime(channelData.created_at) }}</p>
            </div>
          </button>
        </div>

        <div v-if="activeConversation">
          <h2 class="font-semibold my-8">Suggested Responses</h2>
          <slot name="message-options" :setMessage="setMessage"></slot>
        </div>

      </div>
    </div>
    <div class="flex flex-col flex-grow">
      <div class="w-full shadow-sm text-center">{{ activeConversation }}</div>
      <div>
        <!-- WE ARE LOOPING SO THAT WE CAN PING INACTIVE CHATS-->
        <div v-for="channelData in channelsList">
          <!-- TEMP::isAuth is for ensuring proper build, delete after dev stage -->
          <Chat :route="route"
                :messages-initial="channelData.messages"
                :user="user"
                :channelId="channelData.id"
                v-show="activeConversation === channelData.id"
                @ping="notify(channelData.id)"
                :ref="`chat-` + channelData.id"
                :isAuth="true"
          >
            <template v-slot:info>
              <div v-if="showResultQuestion || channelData.result">
                <div v-if="!channelData.result" class="text-center my-2">
                  <div class="text-md text-gray-500 mb-2">
                    How did this conversation go?
                  </div>
                  <div class="inline-flex mx-auto" role="group" aria-label="Button group">
                    <div class="text-center mx-auto">
                      <slot name="result-options" :setResult="setResult" :channelID="channelData.id"
                            :selected="channelData.result"></slot>
                      <button v-for="(result,index) in results" :class="`h-10 px-5 text-gray-100 transition-colors duration-150 focus:shadow-outline` +  (index === '1' ? ` rounded-l-lg` : ( index === '3' ? ' rounded-r-lg' : '' ))
                                + (channelData.id == index ? ` bg-blue-400  hover:bg-blue-300` : ` bg-gray-400 hover:bg-gray-300`)"
                              @click="setResult(channelData.id, index)">
                        {{ result }}
                      </button>

                    </div>
                  </div>
                </div>
                <div v-else>
                  <p class="text-md text-gray-500 mt-2 text-center">
                    This conversation has been marked as "{{ results[channelData.result] }}".
                    <button class="text-blue-500 hover:text-blue-400"
                            @click="channelData.result = null; showResultQuestion=true">Update
                    </button>
                  </p>
                </div>
              </div>
              <div v-else class="text-md text-gray-500 mt-2 text-center">
                Mark conversation as
                <button type="button" class="text-blue-500 hover:text-blue-400" @click="showResultQuestion=true">
                  complete.
                </button>
              </div>
            </template>
          </Chat>
        </div>
      </div>
    </div>
  </div>
</template>